import React, { useContext, useState } from 'react'
import RHS from "../RHS/RHS";
import Tab from "react-bootstrap/Tab";
import styles from "./RiskHealth.module.scss";
import overviewImg from "assets/images/ultraWideHomeCenter/Overview.png";
import RiskHeader from './components/RiskHeader/RiskHeader';
import Overview from './components/Overview/Overview';
import Discover from './components/Discover/Discover';
import Incidents from './components/Incidents/Incidents';
import Mitigate from './components/Mitigate/Mitigate';
import AppDataContext from 'context/AppDataContext';
import RealTimeCollaborator from './components/RealTimeCollaborator/RealTimeCollaborator';

 

export default function RiskHealth() {

  const { setToggleModal, setGridModalShow, setAddModalShow } = useContext(AppDataContext);
  const [ tabNav , setTabNav] = useState('Overview');
  const [isCollaboratorStarted, setCollaborator] = useState(false);
  const [isCollaboratorLoader, setCollaboratorLoader] = useState(false);
  const tabLabels = ["Overview", "Discover", "Incidents", "Mitigate"];
  const addToDashboard = () => {
    setToggleModal(true);
    setAddModalShow(true);
  };
  const openGrid = () => {
    setToggleModal(true);
    setGridModalShow(true);
  };

  const collaboratorHandler = () => {
    setCollaboratorLoader(true);
    
    setTimeout(() => {
      setCollaboratorLoader(false);
      onTabNav(tabLabels[3]);
      setCollaborator(true);
    },3000)

  }
  const endCollaborationHandler = () => {
    setCollaborator(false);
  }

  const onTabNav = (tabKey: string) => {
    setTabNav(tabKey);
  };

    const renderSwitch = () => {
      switch (tabNav) {
        case tabLabels[1]:
          return <Discover />;
        case tabLabels[2]:
          return <Incidents />;
        case tabLabels[3]:
          return <Mitigate />;
        default:
          return <Overview />;
      }
    };


    const toNextTab = () => {
      let tabIndex = tabLabels.findIndex(label => label === tabNav) + 1;
      setTabNav(tabLabels[tabIndex]);
    };
    const toPrevTab = ()=> {
      let tabIndex = tabLabels.findIndex((label) => label === tabNav) - 1;
      setTabNav(tabLabels[tabIndex]);
    };

  return (
    <div className="row fh">
      <div className="col-8 divider-h fh ph-5 center-column position-relative">
        {/* Header */}
        <RiskHeader
          onTabNav={onTabNav}
          addToDashboard={addToDashboard}
          openGrid={openGrid}
          collaboratorHandler={collaboratorHandler}
          tabNav={tabNav}
        />

        {renderSwitch()}

        <div className={styles.btnHolder}>
          <button
            className="btn btn-outline-secondary"
            disabled={tabNav === tabLabels[0]}
            onClick={toPrevTab}
          >
            <i className="icon-arrow-up"></i>
          </button>
          <button
            className="btn btn-outline-secondary"
            disabled={tabNav === tabLabels[3]}
            onClick={toNextTab}
          >
            <i className="icon-arrow-down"></i>
          </button>
        </div>
      </div>
      <div className="col pt-4 fh">
        {isCollaboratorStarted ? (
          <RealTimeCollaborator
            endCollaborationHandler={endCollaborationHandler}
          />
        ) : ( <RHS tabNav={tabNav} tabs={tabLabels} /> )}
      </div>

      {/* Loader */}
      {isCollaboratorLoader && (
        <div className={styles.collaborationLoaderOverlay}>
          <div className={styles.collaborationLoaderPanel}>
            <div className={styles.collaborationIcon}>
              <i className="icon-phone-call"></i>
            </div>
            <h5>Connecting to Real Time Collaborator</h5>
          </div>
        </div>
      )}
    </div>
  );
}
